import { companyAvatar } from 'Services/avatarGenerator'
import { default as locale } from 'date-fns__legacy__/locale/pt'
import format from 'date-fns__legacy__/format'
import parse from 'date-fns__legacy__/parse'
import quotationDeadline from 'Enums/quotationDeadline'
import { ApiQuoteReadOnlyDetail, ApiQuoteReadOnlyHistoryChat } from 'Types/QuoteReadOnly/Api'
import { QuoteReadOnlyChatHistory, QuoteReadOnlyDetails, QuoteReadOnlyInterestedCompanies } from 'Types/QuoteReadOnly/App'

const fixZipcode = (zipcode) => {
  const firstHalf = zipcode.slice(0, 5)
  const secondHalf = zipcode.slice(5, 8)

  return zipcode.includes('-')
    ? zipcode
    : firstHalf + '-' + secondHalf
}

export const parseInteresteCompanies = (item): QuoteReadOnlyInterestedCompanies => {
  return {
    amount: item.amount,
    companyId: item.companyId,
    logo: companyAvatar(item.logoUrl, item.name),
    name: item.name,
    status: item.status
  }
}


export const parseReadOnlyDetails = (item: ApiQuoteReadOnlyDetail): QuoteReadOnlyDetails => {
  return {
    token: item.identifier,
    category: item.category,
    serviceType: item.serviceType,
    created: format(parse(item.requestDate), 'DD/MM/YYYY', { locale }),
    interestedCompanies: item.interestedCompanies.map(parseInteresteCompanies),
    expireAt: format(parse(item.readOnlyExpireAt), 'DD/MM/YYYY [às] HH:mm', { locale }),
    requestBy: item.requestBy,

    request: {
      questionList: item.formAnswers,
      details: item.description,
      deadline: quotationDeadline.getDescriptionByValue(item.periodStartOfService),
    },

    address: {
      street: item.address.street,
      number: item.address.streetNumber,
      details: item.address.complementary,
      neighborhood: item.address.neighborhood,
      zipcode: fixZipcode(item.address.zipCode),
      city: item.address.city,
      state: item.address.state,
      name: item.address.description,
    },
  }
}

export const parseHistoryChat = (item: ApiQuoteReadOnlyHistoryChat): QuoteReadOnlyChatHistory => {
  return {
    name: item.name,
    createAt: format(parse(item.dateCreated), 'DD/MM/YYYY [às] HH:mm', { locale }),
    message:item.message
  }
}
export default {
  parseReadOnlyDetails
}